var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApphighPriorityDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    rx: 10,
    fill: "#F3F3F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2207 12.1582H9.79102L9.49219 6.43359H11.5195L11.2207 12.1582ZM9.46875 14.1621C9.46875 13.834 9.55664 13.5859 9.73242 13.418C9.9082 13.25 10.1641 13.166 10.5 13.166C10.8242 13.166 11.0742 13.252 11.25 13.4238C11.4297 13.5957 11.5195 13.8418 11.5195 14.1621C11.5195 14.4707 11.4297 14.7148 11.25 14.8945C11.0703 15.0703 10.8203 15.1582 10.5 15.1582C10.1719 15.1582 9.91797 15.0723 9.73828 14.9004C9.55859 14.7246 9.46875 14.4785 9.46875 14.1621Z",
    fill: "#68778D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApphighPriorityDone);
export default __webpack_public_path__ + "static/media/app.high_priority_done.27df296b389f4b4f76f82381860036fc.svg";
export { ForwardRef as ReactComponent };